import { Component, OnInit } from '@angular/core';
import { Partner } from '../../models/partner';
import { PartnerStateService } from '../../services/partner-state.service';

@Component({
  selector: 'app-current-partner-contact',
  templateUrl: './current-partner-contact.component.html',
  styleUrls: ['./current-partner-contact.component.css']
})
export class CurrentPartnerContactComponent implements OnInit {

  constructor(
    private partnerStateService: PartnerStateService,
  ) { }

  ngOnInit() {
  }

  get partner(): Partner {
    return this.partnerStateService.loggedInPartner;
  }
}
